import React from 'react'
import Jumbotron from '../../Component/Jumbotron'

import Angular from '../../assets/certificados/angular.png'
import Angular2 from '../../assets/certificados/angular2.jpg'
import Embc from '../../assets/certificados/embc.png'
import Front from '../../assets/certificados/front2.jpg'
import Front2 from '../../assets/certificados/frontcamp.png'
import Gft from '../../assets/certificados/gft.jpg'
import Html from '../../assets/certificados/html.png'
import Java from '../../assets/certificados/java.jpg'
import Oracle from '../../assets/certificados/oraclealura.png'
import React2 from '../../assets/certificados/react2.jpg'
import Responsive from '../../assets/certificados/respcamp.png'
import Scrum from '../../assets/certificados/scrum.jpg'
import Seo from '../../assets/certificados/seo.png'
import Vue from '../../assets/certificados/vue.png'
import Web from '../../assets/certificados/web.png'
import Data from '../../assets/certificados/data.png'
import Sociedade from '../../assets/certificados/society.png'
import Eua from '../../assets/certificados/eua.png'
import Campus from '../../assets/certificados/cpnatal.png'
import Virtual from '../../assets/certificados/virtual.png'

import { Row, Col } from 'antd'

const Certificates = () => {

    const certificates = [
        {
            id: 1,
            path: Embc
        },
        {
            id: 2,
            path: Angular
        },
        {
            id: 3,
            path: Seo
        },
        {
            id: 4,
            path: Front2
        },
        {
            id: 5,
            path: Responsive
        },
        {
            id: 6,
            path: Html
        },
        {
            id: 7,
            path: Vue
        },
        {
            id: 8,
            path: Oracle
        },
        {
            id: 9,
            path: Web
        },
        {
            id: 10,
            path: Data
        },
        {
            id: 11,
            path: Angular2
        },
        {
            id: 12,
            path: Front
        },
        {
            id: 13,
            path: Gft
        },
        {
            id: 14,
            path: Java
        },
        {
            id: 15,
            path: React2
        },
        {
            id: 16,
            path: Scrum
        },
        {
            id: 17,
            path: Virtual
        },
        {
            id: 18,
            path: Campus
        },
        {
            id: 19,
            path: Sociedade
        },
        {
            id: 20,
            path: Eua
        },
    
    ]

    return (
        <>
            <Jumbotron height={40} message={'Certificados'}/>

            <Row justify='center' style={{padding: '40px 0', width: '100%'}}>
                {certificates.map(item=> {
                    return(
                        <Col xs={23} sm={23} md={10} lg={6} xl={6} key={item.id} style={{margin: '20px'}}>
                            <img src={item.path} alt={item.path} width={'100%'} style={{position: 'relative', zIndex: '2', borderRadius: '5px'}}/>
                        </Col>
                    )
                })}
            </Row>
        </>
    )
}

export default Certificates

